import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import SettingFields from './SettingFields'

export const SettingEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <SettingFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default SettingEdit
